(() => {
  const config = document.querySelector('script[data-rating-label]');
  const ratingLabel = config ? config.dataset.ratingLabel : '__RATING__/5 · __COUNT__ reviews';
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const mobile = window.matchMedia('(max-width: 749px)');
  let scheduled = false;
  const connectedChats = new WeakSet();

  function syncReviews() {
    document.querySelectorAll('.product__info-container .jdgm-prev-badge').forEach(badge => {
      const rating = Number(badge.dataset.averageRating);
      const count = Number(badge.dataset.numberOfReviews);
      const text = badge.querySelector('.jdgm-prev-badge__text');
      if (!text || !Number.isFinite(rating) || !Number.isFinite(count) || count <= 0) return;
      const label = ratingLabel.replace('__RATING__', rating.toFixed(2)).replace('__COUNT__', count.toLocaleString(document.documentElement.lang));
      let link = text.querySelector('.hone-review-link');
      if (!link) {
        link = document.createElement('a');
        link.className = 'hone-review-link';
        link.href = '#judgeme_product_reviews';
        link.addEventListener('click', event => event.stopPropagation());
        text.replaceChildren(link);
      }
      if (link.textContent !== label) link.textContent = label;
    });
  }

  function syncChat() {
    document.querySelectorAll('shopify-chat').forEach(chat => {
      const root = chat.shadowRoot;
      if (!root) return;
      if (!root.querySelector('#hone-compact-chat-style')) {
        const style = document.createElement('style');
        style.id = 'hone-compact-chat-style';
        style.textContent = '@media(max-width:749px){.activator-nudge{right:12px!important;left:auto!important;bottom:calc(var(--hone-chat-bottom,12px) + env(safe-area-inset-bottom,0px))!important}.activator{box-sizing:border-box!important;width:48px!important;min-width:48px!important;max-width:48px!important;height:48px!important;min-height:48px!important;padding:12px!important;border-radius:50%!important;justify-content:center!important;gap:0!important;box-shadow:0 2px 12px rgba(0,0,0,.16)!important}.activator__label{display:none!important}.activator__icon,.activator__icon svg{width:22px!important;height:22px!important}}';
        root.append(style);
      }
      if (!connectedChats.has(chat)) {
        connectedChats.add(chat);
        new MutationObserver(schedule).observe(root,{childList:true,subtree:true,attributes:true,attributeFilter:['aria-expanded']});
      }
      let bottom = 12;
      if (mobile.matches) {
        document.querySelectorAll('mobile-sticky-atc[data-visible="true"],#PBarNextFrameWrapper').forEach(bar => {
          const rect = bar.getBoundingClientRect();
          if (rect.height > 0 && rect.height < innerHeight / 2 && rect.bottom >= innerHeight - 2 && rect.top < innerHeight) {
            bottom = Math.max(bottom, innerHeight - rect.top + 12);
          }
        });
      }
      const value = bottom + 'px';
      if (chat.style.getPropertyValue('--hone-chat-bottom') !== value) chat.style.setProperty('--hone-chat-bottom',value);
    });
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {scheduled = false;syncReviews();syncChat();});
  }

  document.addEventListener('click', event => {
    const link = event.target.closest('[data-hone-scroll]');
    if (!link) return;
    const target = document.getElementById(link.hash.slice(1));
    if (!target) return;
    event.preventDefault();
    target.focus({preventScroll:true});
    target.scrollIntoView({behavior:reducedMotion.matches ? 'auto' : 'smooth',block:'start'});
  });

  function start() {
    syncReviews();
    syncChat();
    new MutationObserver(schedule).observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['data-average-rating','data-number-of-reviews','data-visible']});
    window.addEventListener('scroll',schedule,{passive:true});
    window.addEventListener('resize',schedule,{passive:true});
    document.addEventListener('shopify:section:load',schedule);
    mobile.addEventListener('change',schedule);
    if (window.customElements) customElements.whenDefined('shopify-chat').then(schedule);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
})();
